module.exports = __webpack_public_path__ + "staticvuejsweb/img/bubble.8e466cc0.png";